
import { defineComponent } from 'vue';
import { writeWorkspaceClone } from '@/firebase/database';
import { useGlobalStore } from '@/modules/globalModule/store';
import { useProjectManagerStore } from '../store';
export default defineComponent({
  name: 'SavedWorkspace',
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    },
    canCreate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    openWorkspace(): void {
      const globalStore = useGlobalStore();
      globalStore.loadWorkspace(this.id);
      this.$router.push('/controlCenter/' + this.id);
    },
    async onDuplicate() {
      const pmStore = useProjectManagerStore();
      let canCreate = await pmStore.canCreateWorkspaceAsync();
      if (canCreate) writeWorkspaceClone(this.id);
    },
    onDelete() {
      this.$emit('deleteProject', this.name, this.id);
    }
  },
  emits: ['deleteProject', 'duplicateProject']
});
